<template>
  <div>
    <van-field
      v-model="useMessage.所属项目"
      readonly
      :disabled="true"
      required
      label="当前项目"
      :rules="[rule_required]"
      placeholder="请在个人中心选择所在项目"
    />
    <van-field
      v-model="useMessage.客户姓名"
      name="username"
      label="姓名"
      required
     
      :rules="[rule_required]"
      placeholder="请输入姓名"
    />
    <van-field name="sex" label="性别" required>
      <template #input>
        <van-radio-group v-model="useMessage.性别" direction="horizontal">
          <van-radio name="男">男</van-radio>
          <van-radio name="女">女</van-radio>

        </van-radio-group>
      </template>
    </van-field>
    <!-- <van-field
      v-if="useMessage._id"
      :disabled="true"
      v-model="useMessage.客户电话"
      type="tel"
      name="tel"
      required
      label="电话"
      placeholder="请填写电话"
    /> -->
     <van-cell v-if="useMessage._id" title="客户电话" :value="useMessage.客户电话|maskTel"></van-cell> 
    <van-field
      v-else
      v-model="useMessage.客户电话"
      type="tel"
      name="tel"
      required
      label="电话"
      placeholder="请填写电话"
    />
    <van-field
      readonly
      clickable
      required
      name="pcc"
      :value="useMessage.客户地区"
      label="地区选择"
      :rules="[rule_required]"
      placeholder="点击选择省市区"
      @click="showArea = true"
    />
    <van-field
      v-model="useMessage.详细地址"
      required
      type="text"
      name="detail"
      label="详细地址"
      placeholder="请填写详细地址"
      :rules="[{ required: true, message: '请填写详细地址' }]"
    />
    <van-field
      v-model="useMessage.备注"
      type="text"
      name="remark"
      label="备注"
      placeholder="备注"
    />
    <!-- <div style="margin: 16px">
        <van-row>
          <van-col span="12"
            >
            <van-button  round block  @click.prevent="$emit('handlerStep', -1)"
              >取消</van-button
            >
          </van-col>
          <van-col span="12">
            <van-button  round block  @click.prevent="$emit('handlerStep', 1)"
              >下一步</van-button
            >
          </van-col>
        </van-row>
      </div> -->

    <!-- 地区选择弹窗 -->
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { area1 } from "@/utils/area";
import api from "@/api/apis";
export default {
  name: "userMessage",
  props: {
    useMessage: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      projectname: "",
     
      areaList: area1,
      showArea: false,
      showPopup: false,
      popubIndex: -1,
      questionnaire: [],
      popupList: [],
      rule_required: { trigger: "onBlur", required: true, message: "*" },
      //pattern: /^[1][3,4,5,7,8][0-9]{9}$/, //用户名正则校验
      rule_tel: {
        trigger: "onBlur",
        validator: (value) => {
          return /^(0|86|17951)?(13[0-9]|15[012356789]|16[0-9]|19[0-9]|17[35678]|18[0-9]|14[57])[0-9]{8}$/.test(
            value
          );
        },
        message: "不是有效的手机号",
      },
    };
  },
  created() {
    //this.getQuestionnaire();
   // this.projectname = localStorage.getItem("projectname");
  },

  methods: {
    
    
    //选择城市
    onConfirm(values) {
      this.useMessage.客户地区 = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("-");
      console.log(this.value);
      this.showArea = false;
    },
  },
  components: {},
};
</script>